import React from "react";
import { compact, rupee } from "../../lib/format";

export function StatCard({ icon: Icon, label, value, sub, accent = "gold", testid }) {
  const ring = { gold: "text-amber-400", emerald: "text-emerald-400", blue: "text-blue-400", red: "text-red-400" }[accent];
  return (
    <div className="card-surface rounded-2xl p-5 hover:border-amber-500/40 transition-colors animate-fadeup" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-wider text-slate-500 font-medium">{label}</span>
        {Icon && <Icon size={18} className={ring} />}
      </div>
      <div className="font-display font-extrabold text-2xl sm:text-3xl mt-2 text-slate-50">{value}</div>
      {sub && <div className="text-xs text-slate-400 mt-1">{sub}</div>}
    </div>
  );
}

export function Panel({ title, children, action, className = "" }) {
  return (
    <div className={`card-surface rounded-2xl p-5 ${className}`}>
      {(title || action) && (
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display font-bold text-lg">{title}</h3>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export function EntitySelect({ label, value, onChange, options, testid }) {
  return (
    <div className="flex items-center gap-2">
      {label && <span className="text-xs text-slate-500">{label}</span>}
      <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
        className="bg-[#16336B] border hairline rounded-lg px-3 py-1.5 text-sm text-slate-200 focus:border-amber-500 outline-none">
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </div>
  );
}

export function DataTable({ columns, rows, testid, onRowClick }) {
  return (
    <div className="overflow-x-auto" data-testid={testid}>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b hairline">
            {columns.map((c) => <th key={c.key} className="py-2.5 px-3 font-medium whitespace-nowrap">{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} onClick={() => onRowClick?.(r)}
              className={`border-b border-white/5 hover:bg-amber-500/5 transition-colors ${onRowClick ? "cursor-pointer" : ""}`}>
              {columns.map((c) => (
                <td key={c.key} className="py-2.5 px-3 whitespace-nowrap">{c.render ? c.render(r) : r[c.key]}</td>
              ))}
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={columns.length} className="py-8 text-center text-slate-600">No data for this period.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export const Empty = ({ text }) => (
  <div className="py-12 text-center text-slate-600 text-sm">{text}</div>
);
